import React from "react";
import logo from "./Avanade Color Logo RGB.png";
export default function AvanadeLogo() {
    return (
        <div style={{ paddingTop: "0.2rem" }}>
            <a href="/">
                <img alt="Avanade" height={50} src={logo} />
            </a>
        </div>
    );
}
